import { usePage } from "@inertiajs/inertia-react";
import { LabeledInput } from "@/Components/Form";
import { Search } from "react-feather";
import QuestionAnswers from "@/Components/Dashboard/QuestionAnswers";
import { useEffect, useState } from "react";
import { Dropdown } from "@/Components";
import { useAtom } from "jotai";
import { dashboardSortAtom } from "@/Stores";

function QuestionsList() {
  const questions = usePage().props?.questions.data || [];
  const questionsOrder = usePage().props?.answers_order || [];
  const teams = usePage().props?.teams?.data || [];

  const [search, setSearch] = useState("");

  return (
    <>
      <div className="flex justify-between gap-4 max-md:flex-col md:items-end">
        <LabeledInput
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          placeholder="Search activity"
          className="pr-10"
          containerClass="max-w-full w-96"
          unit={<Search className="relative -top-1" />}
        />

        <SortDropdown />
      </div>

      <div>
        {questionsOrder.map((questionID) => {
          const question = questions.find((q) => q.id === parseInt(questionID));

          const numberTeamsWithQuestion = teams.filter((team) => {
            return team.questions.find((q) => q.id === questionID);
          }).length;

          if (
            search &&
            !question.title.toLowerCase().includes(search.toLowerCase())
          ) {
            return null;
          }

          return (
            <QuestionAnswers
              key={questionID}
              question={question}
              count={numberTeamsWithQuestion}
            />
          );
        })}
      </div>
    </>
  );
}

const SortDropdown = () => {
  const [sort, setSort] = useAtom(dashboardSortAtom);

  const sortOptions = [
    { value: "title.asc", label: "Name A-Ö" },
    { value: "title.desc", label: "Name Ö-A" },
    { value: "emission.desc", label: "Most emission" },
    { value: "emission.asc", label: "Least emission" },
    { value: "last_reported.desc", label: "Reported most recent" },
    { value: "last_reported.asc", label: "Reported least recent" },
  ];

  // On load set the sort to value from URL param if it exists
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sortParam = params.get("sort");
    if (
      sortParam &&
      sortParam !== sort &&
      sortOptions.find((option) => option.value === sortParam)
    ) {
      setSort(sortParam);
    }
  }, []);

  return (
    <Dropdown
      options={sortOptions}
      title="Sort on"
      placeholder={
        sortOptions.find((o) => o.value === sort)?.label || "Name A-Ö"
      }
      onSelect={(value) => {
        setSort(value);
      }}
    />
  );
};

export default QuestionsList;
